:host {
  @include cms-default-grid-container;
  margin-bottom: var(--cms-components-mb);
}

.newsletter-inner {
  padding: var(--cms-spacing-100);
  background-color: var(--cms-semanticColors-base-medium-background);
  grid-area: var(--cms-default-grid-area);
  justify-content: space-between;
}

.headline-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: var(--cms-spacing-075);
}

.icon-wrapper {
  margin-right: var(--cms-spacing-050);
  height: 33px;
  display: flex;
  align-items: center;
}

.newsletter-headline {
  text-align: center;
  font-family: var(--cms-brandfont1);
  font-weight: var(--cms-heading-base-font-weight);
  line-height: var(--cms-line-height-150);
  font-size: var(--cms-font-size-125);
  color: var(--cms-semanticColors-base-strong-text);
}

.newsletter-cta {
  width: 100%;
}

@include media-width($breakpoint-sm) {
  .newsletter-inner {
    --cms-default-grid-area: auto / 3 / auto / span 8;
    display: flex;
    align-items: center;
  }

  .headline-wrapper {
    flex: 0 50%;
    justify-content: flex-start;
    margin-bottom: 0;
  }

  .button-wrapper {
    width: 40%;
  }
}